import Profile from '~/assets/img/profile/profile.png';
import * as S from './ChatProfile.styled';

interface ChatProfileProps {
  characters: string[];
  alert?: boolean;
  size?: number;
}

export default function ChatProfile({
  size = 46,
  characters,
  alert,
}: ChatProfileProps) {
  return (
    <S.Container
      size={size}
      className={`profile ${characters.length > 1 ? 'multi' : ''}
      ${alert ? 'alert' : ''}`}
    >
      {characters.length === 0 ? (
        <img src={Profile} alt='profile' loading='lazy' />
      ) : (
        characters.slice(0, 2).map((image, index) => {
          return <img src={image ? image : ''} alt='profile' key={index} />;
        })
      )}
    </S.Container>
  );
}
